export default __webpack_public_path__ + "static/media/pic7.e8d0ed85.png";